//@ts-nocheck
import { Subject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

export function hexColorToRgb(hexStr: string) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexStr);
    if (result) {
        return {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        };
    }

    return {
        r: 255,
        g: 255,
        b: 255,
    }
}

export async function sleep(milliseconds: number) {
    await (() => new Promise(resolve => setTimeout(resolve, milliseconds)))();
}

function observerProcess<T>(process: (s: Subject<T>) => void): Observable<T> {
    const result = new Subject<T>();
    process(result);
    return result.asObservable();
}

export async function callAsync<T>(process: (s: Subject<T>) => void): Promise<T> {
    const result = await observerProcess<T>(process).pipe(take(1)).toPromise();
    return result;
}

export function b64toBlob(b64Data: string, contentType: string = '', sliceSize: number = 512): Blob {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}

export function tableAsText(content) {
    let contentStr = '';
    if (Array.isArray(content) && content.length === 1) {
        const firstVal = content[0];
        if (Array.isArray(firstVal) && firstVal.length === 1) {
            const singleVal = firstVal[0];
            if (Array.isArray(singleVal) || typeof singleVal === 'object' || typeof singleVal === 'undefined') {
                contentStr = JSON.stringify(singleVal);
            }
            else if (typeof singleVal === 'string') {
                contentStr = singleVal;
            }
            else {
                contentStr = `${singleVal}`;
            }
        }
        else {
            contentStr = JSON.stringify(firstVal);
        }
    }
    else {
        contentStr = JSON.stringify(content);
    }

    return contentStr;
}
